export const env = {
  FLIGHT_API_BASE_URL: process.env.REACT_APP_FLIGHT_BASE_URL || "",
  MERCHANT_ID: process.env.REACT_APP_MERCHANT_ID || "",
  MERCHANT_KEY: process.env.REACT_APP_MERCHANT_KEY || "",
  PG_DECRYPTION_URL: process.env.REACT_APP_PG_DECRYPTION_URL || "",
  PG_ENCRYPTION_URL: process.env.REACT_APP_PG_ENCRYPTION_URL || "",
  REACT_APP_IP_ADDRESS: process.env.REACT_APP_IP_ADDRESS || "",
  REACT_APP_HOTEL_USERNAME: process.env.REACT_APP_HOTEL_USERNAME || "",
  REACT_APP_HOTEL_PASSWORD: process.env.REACT_APP_HOTEL_PASSWORD || "",
};
